<script>
import {
  QZ_INPUT_STYLE,
  addQzDirectives,
} from '@/constants/common';

import VTextField from 'vuetify/lib/components/VTextField';

export default {
  name: 'qz-text-field',
  functional: true,
  render (h, { data, listeners }) {
    return h(VTextField, {
      ...data,
      ref: data.ref,
      props: data.props,
      attrs: {
        ...data.attrs, ...QZ_INPUT_STYLE,
      },
      on: {
        ...listeners,
      },
      directives: addQzDirectives(data),
    });
  },
};
</script>
